export default __webpack_public_path__ + "static/media/pa.b648d4d5.mp3";